import {TAG_TYPE__STOCKTAKE} from '../../common/constants/Tags.js'
import {
  addTagToStocktakes,
  removeTagFromStocktakes,
  stocktakeTagOptionsSelector,
  stocktakeTagOptionTokensSelector,
} from '../../data/stocktakeTags.js'
import {
  hasStocktakeManageTagPermissionSelector,
  hasStocktakeManageTagOnStocktakePermissionSelector,
} from '../../data/me.js'
import ManageTagFilter from '../../common/components/ManageTagFilter.js'
import {
  createAndApplyTagToStocktakes,
  createStocktakeTagQuantityMapSelector,
} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'
import {useMemo} from 'react'

/**
 * AddStocktakeTagsDropdown component
 *
 * @param {Object} props - The component props.
 * @param {Array} props.referenceIDs - The reference IDs of the Stocktakes to which tags will be applied.
 *
 * @returns
 */
export default function AddStocktakeTagsDropdown({referenceIDs}) {
  const stocktakeTagQuantityMapSelector = useMemo(
    () => createStocktakeTagQuantityMapSelector(),
    [],
  )

  const stocktakeTagOptions = useSelector(stocktakeTagOptionsSelector)
  const stocktakeTagOptionTokens = useSelector(stocktakeTagOptionTokensSelector)
  const tagQuantityMap = useSelector((state) =>
    stocktakeTagQuantityMapSelector(state, {referenceIDs}),
  )
  const hasStocktakeManageTagPermission = useSelector(
    hasStocktakeManageTagPermissionSelector,
  )
  const hasStocktakeManageTagOnStocktakePermission = useSelector(
    hasStocktakeManageTagOnStocktakePermissionSelector,
  )

  if (!hasStocktakeManageTagOnStocktakePermission) {
    return null
  }

  return (
    <li className="inline-block divider--left">
      <ManageTagFilter
        dropdown="APPLY_STOCKTAKE_TAG_FILTER"
        onSelect={(tag) => {
          if (tagQuantityMap[tag.id] === 'all') {
            removeTagFromStocktakes(tag.id, referenceIDs)
          } else {
            addTagToStocktakes(tag.id, referenceIDs)
          }
        }}
        tagOptions={stocktakeTagOptions}
        tagOptionTokens={stocktakeTagOptionTokens}
        tagQuantityMap={tagQuantityMap}
        hasManageTagPermission={hasStocktakeManageTagPermission}
        tagType={TAG_TYPE__STOCKTAKE}
        onCreateAndApplyClick={() =>
          createAndApplyTagToStocktakes(referenceIDs)
        }
      />
    </li>
  )
}
